/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ before: NonNullable<unknown>, after: NonNullable<unknown> }} Draft_Row_ChangedInputs */

const en_us2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Targets: ${i?.before} → ${i?.after}`)
};

const pt_br2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metas: ${i?.before} → ${i?.after}`)
};

const es_419_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metas: ${i?.before} → ${i?.after}`)
};

const pt_pt2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metas: ${i?.before} → ${i?.after}`)
};

const fr_fr2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Objectifs : ${i?.before} → ${i?.after}`)
};

const de_de2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ziele: ${i?.before} → ${i?.after}`)
};

const it_it2_draft_row_changed = /** @type {(inputs: Draft_Row_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obiettivi: ${i?.before} → ${i?.after}`)
};

/**
* | output |
* | --- |
* | "Targets: {before} → {after}" |
*
* @param {Draft_Row_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_row_changed = /** @type {((inputs: Draft_Row_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Row_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_row_changed(inputs)
	if (locale === "es-419") return es_419_draft_row_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_row_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_row_changed(inputs)
	if (locale === "de-DE") return de_de2_draft_row_changed(inputs)
	if (locale === "it-IT") return it_it2_draft_row_changed(inputs)
	return en_us2_draft_row_changed(inputs)
});
export { draft_row_changed as "draft.row_changed" }